import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

export interface NavigationItem {
  id: string;
  label: string;
  icon: string;
  route?: string;
  children?: NavigationItem[];
  badge?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  @Input() isCollapsed = false;
  @Output() navigationClick = new EventEmitter<void>();

  currentRoute = '';

  navigationItems: NavigationItem[] = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: 'dashboard',
      route: '/dashboard'
    },
    {
      id: 'clients',
      label: 'Clients',
      icon: 'people',
      route: '/clients'
    },
    {
      id: 'policies',
      label: 'Policies',
      icon: 'description',
      route: '/policies',
      children: [
        {
          id: 'active-policies',
          label: 'Active Policies',
          icon: 'check_circle',
          route: '/policies/active'
        },
        {
          id: 'pending-policies',
          label: 'Pending',
          icon: 'schedule',
          route: '/policies/pending',
          badge: '5'
        },
        {
          id: 'expired-policies',
          label: 'Expired',
          icon: 'cancel',
          route: '/policies/expired'
        }
      ]
    },
    {
      id: 'claims',
      label: 'Claims',
      icon: 'report_problem',
      route: '/claims',
      badge: '12'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: 'analytics',
      route: '/reports'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: 'settings',
      route: '/settings'
    }
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Track current route for navigation highlighting
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });
    
    // Set initial route
    this.currentRoute = this.router.url;
  }

  onItemClick(item: NavigationItem): void {
    if (item.disabled) {
      return;
    }

    if (item.route) {
      this.router.navigate([item.route]);
    }

    this.navigationClick.emit();
  }

  isActiveRoute(route: string): boolean {
    return this.currentRoute === route || this.currentRoute.startsWith(route + '/');
  }

  hasActiveChild(item: NavigationItem): boolean {
    if (!item.children) {
      return false;
    }

    return item.children.some(child => 
      child.route && (this.currentRoute === child.route || this.currentRoute.startsWith(child.route + '/'))
    );
  }

  trackByItemId(index: number, item: NavigationItem): string {
    return item.id;
  }
}